import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintManager_ds_get_order_class_by_orderClassIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { orderClassId?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string, OrderClassTypeId?: number, OrderTypeId?: number } }> 
  {
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_get_order_class_by_orderClassId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      orderClassId?: number    }) {
      return false;
    }
}
